import React, {useState, useEffect} from "react";
import { Link } from 'react-router-dom';
import {Links} from '../routes/PathLink'
import SavePriceInd from '../ui/SavePriceInd'


import { amount_format,API_ENDPOINT , IMG_URL , showRatingP } from '../components/config/Common'
/*import {API_ENDPOINT, APP_URL, APP_NAME, IMG_URL, amount_format,discount, LIMIT, replaceWithBr, showRating} 
from './config/Common'
*/

const ProductCard = ({product,user_type}) => {
  
  return (
    <Link to={`${Links.PRODUCT}/${product.product_slug}`}>
      <article className="group product-card cart-type-krypton h-full cursor-pointer overflow-hidden rounded border border-border-200 bg-light transition-shadow duration-200 hover:shadow-sm dark:bg-gray-700 dark:border-none">
        <div className="relative flex h-44 w-auto items-center justify-center sm:h-44">
          <div className="absolute top-3 flex gap-3">
              {
               product.is_featured == 1 && 
               <div class=" rounded bg-yellow-500 px-1.5 text-xs font-semibold leading-6 text-light ltr:left-3 rtl:right-3 sm:px-2 md:top-4 md:px-2.5 ltr:md:left-4 rtl:md:right-4">Featured</div>
               }
              {
               product.is_popular == 1 && 
               <div class=" rounded bg-[#7D87D4] px-1.5 text-xs font-semibold leading-6 text-light ltr:left-3 rtl:right-3 sm:px-2 md:top-4 md:px-2.5 ltr:md:left-4 rtl:md:right-4">Popular</div>
               }
               {
               product.is_verified == 1 && 
               <div class=" rounded bg-[#8D9557] px-1.5 text-xs font-semibold leading-6 text-light ltr:left-3 rtl:right-3 sm:px-2 md:top-4 md:px-2.5 ltr:md:left-4 rtl:md:right-4">Verified</div>
               }
               {
               product.is_upcoming == 1 && 
               <div class=" rounded bg-[#00A09D] px-1.5 text-xs font-semibold leading-6 text-light ltr:left-3 rtl:right-3 sm:px-2 md:top-4 md:px-2.5 ltr:md:left-4 rtl:md:right-4">Upcoming</div>
               }
               {
               product.in_stock == 0 && 
               <div class=" rounded bg-[#CB797B] px-1.5 text-xs font-semibold leading-6 text-light ltr:left-3 rtl:right-3 sm:px-2 md:top-4 md:px-2.5 ltr:md:left-4 rtl:md:right-4">Out Of Stock</div>
               }
            {/*product.badges && product.badges.map((b, i) => (
              <div key={i} className=" rounded bg-yellow-500 px-1.5 text-xs leading-6 text-light ltr:left-3 rtl:right-3 sm:px-2 md:top-4 md:px-2.5 ltr:md:left-4 rtl:md:right-4">{b}</div>
            ))*/}
          </div>
          <img src={`${IMG_URL}/${product.product_image}`} className="h-44 w-full sm:h-44 object-cover" alt={product.product_name} sizes="100vw" />
        </div>
        <header className="relative px-1 py-2 flex flex-col items-start justify-between gap-1">
          <h3 role="button" className="w-full truncate text-sm text-heading capitalize">{product.product_name}</h3>
          <div className="relative flex items-center justify-between">
             {user_type == 'dealer' && product.dealer_price &&  product.dealer_price > 0 ?

            <div className="relative"><span className="text-sm text-accent md:text-base flex items-center"><div className="flex items-center">{amount_format(product.dealer_price)}</div></span></div>
            :
            ( 
              <>
              {product.warranty_price && product.warranty_price > 0 ?
              <>
              <div className="relative"><span className="text-sm text-accent md:text-base flex items-center"><div className="flex items-center">{amount_format(product.warranty_price)}</div></span></div>
              
              </>
              :
              <>
                <div className="relative"><span className="text-sm text-accent md:text-base flex items-center"><div className="flex items-center">{amount_format(product.price)}</div></span></div>
                 
              </>
              }
              </>
            )
             }
          </div>
          {product.ratings &&
          <div class="flex text-xs items-center justify-start gap-1">
            <div class="flex">
            {showRatingP(product.ratings)} 
            </div>
            <div>
              ({product.ratings})
            </div>
          </div>
          }
          <div className="flex bg-light text-accent group-hover:bg-accent group-hover:text-light ease-in duration-300 rounded-full w-[70%] items-center justify-between">
            <div className="uppercase text-xs ease-in duration-300 pl-1 group-hover:pl-2">Add to Cart</div>
            <div className="relative -right-[1px] h-7 w-7 bg-accent text-light group-hover:bg-light group-hover:text-accent rounded-full flex items-center justify-center">
              <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5zM3.14 5l.5 2H5V5H3.14zM6 5v2h2V5H6zm3 0v2h2V5H9zm3 0v2h1.36l.5-2H12zm1.11 3H12v2h.61l.5-2zM11 8H9v2h2V8zM8 8H6v2h2V8zM5 8H3.89l.5 2H5V8zm0 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"></path></svg>
            </div>
          </div>
        </header>
      </article>
    </Link>
  )
}

const CathLabRange = ({title, description, link, cat_id}) => {
    const [user_type, setUser_type] = useState('');
  const [products, setProducts] = useState([]);
    
        useEffect(() => {
            get_cat_product_home();
             const user_type = localStorage.getItem('user_type');
             setUser_type(user_type);
             
          
        }, [cat_id])
    
  
    const get_cat_product_home = () => {
    
        fetch(`${API_ENDPOINT}/get_cat_product_home/${cat_id}`,{
          method: 'GET',
          headers : {        
            'Content-Type': 'application/json',
            'Accept': 'application/json', 
          }
        }).then(function (response) {
            return response.json();
        }).then( (result)=> {
          console.log('category product======',result)
          setProducts(result.data);
        })
      }
  
  
  return (
    <div className="md:flex flex-1 bg-white-100 dark:bg-gray-900 py-10 px-5 items-center gap-5 border-b-2 border-accent">
      <div className="w-full md:w-1/4">
        <h1 className="text-accent text-4xl leading-[40px]" dangerouslySetInnerHTML={{ __html: title }} />
        <div className="text-body py-5 line-clamp-3" dangerouslySetInnerHTML={{ __html: description }} />
        <Link className="order-5 items-center justify-center rounded-full border-2 border-accent bg-accent px-3 py-2 text-sm font-semibold text-white transition-colors duration-300 hover:border-accent hover:bg-accent hover:text-light focus:border-accent focus:bg-accent focus:text-light focus:outline-none sm:order-4 sm:justify-start sm:px-5" to={link}>
          <span>Know More</span>
        </Link>
      </div>
      <div className="w-full md:w-3/4 grid grid-cols-2 md:grid-cols-5 gap-3 pt-10 md:pt-0">
        {products.map((p, idx) => (
          <>
          {idx < 5 && <ProductCard key={idx} product={p} user_type={user_type} />}
          </>
        ))}
      </div>
    </div>
  )
}

export default CathLabRange;
